<div class="white-on-gray" *ngIf="!canViewDigitalWallet">
  <div class="section mb-3 mb-lg-5">
    <div class="subsection">
      <div class="mb-2">
        Each file cannot exceed 7MB. File names cannot exceed the maximum limit of 70 characters. File types such as .jpg, .pdf, .docx, .xls, .msg are accepted. We’ll reach out to you if we need additional information.
      </div>
      <div class="mb-2" *ngIf="isCanadaUser">
        <span>{{ 'claims.edit.whatHappened.documents.subtitle2' | translate }} </span>
        {{ 'claims.edit.whatHappened.documents.subtitle3' | translate }}
      </div>
      <div class="document-upload panel-section">
        <div class="file-error" *ngIf="isDocumentMissing && invoices.length < 1">
            {{ 'claims.edit.whatHappened.documents.errors.invoiceMissing' | translate }}
        </div>
        <div class="file-error" *ngIf="isDocumentMissing && claimReason=='1' && photos.length < 1">
            {{ 'claims.edit.whatHappened.documents.errors.photoMissing' | translate }}
        </div>
        <div class="file-error" *ngFor="let error of errorList">
          The file {{error.filename}} could not be uploaded due to: {{error.error}}.
        </div>
        <div class="file-error" *ngIf="removeDocumentError">
          System error occurred while trying to remove the document. Please try again.
        </div>
        <div class="section-wrapper">
          <div class="document-panel-right mr-sm-1 mr-lg-2">
            <div class="title" *ngIf="proofOfValue!=='1'">
              Proof of Value/Invoice
            </div>
            <div class="title-ssp" *ngIf="proofOfValue==='1'">
              <span class="text">Proof of Value/Invoice</span>
              <span class="sub-text">{{ 'claimsDetail.upload.proofOfValue' | translate }}</span>
            </div>
            <div class="doc-label-req-optional" *ngIf="!highlightRed">Required*</div>
            <div class="doc-label-req-optional-red" *ngIf="highlightRed">Required*</div>
            <div class="uploaded-documents d-flex justify-content-center align-items-center"
              [ngStyle]="{'border-color': (isDocumentMissing && invoices.length < 1) ? 'red' : '#707070'}"
              (click)="!isUploadDisabled && InvoiceInput.click()" upscDragNDrop (onFileDropped)="!isUploadDisabled && uploadDocument($event, 'ONL-Invoice')">              
              <input [disabled]="isUploadDisabled" hidden type="file" #InvoiceInput (change)="uploadDocument($event.target.files, 'ONL-Invoice', $event)" multiple>
              <div class="d-flex flex-column justify-content-center align-items-center">
                <img class="pb-2" src="../../../../../assets/images/upload-file-icon.png">
                <div class="attachments-title pb-2">
                  {{'claimsDetail.upload.message1.1' | translate }}
                  <span class="upload-underline">{{ 'claimsDetail.upload.message2.1' | translate }}</span>
                </div>
                <!-- <div class="pb-2">
                  {{ 'claimsDetail.upload.filesAllowed' | translate }}
                </div> -->
              </div>
            </div>
            <div class="uploaded-attachments">
              <ul class="your-attachments">
                <li class="d-inline-flex justify-content-start align-items-center" *ngFor="let file of invoices">
                  <div>{{file.file.name}}</div>
                  <mat-icon class="delete-icon ml-2" (click)="removeDocument(file, 'ONL-Invoice')">clear</mat-icon>
                </li>
              </ul>
            </div>
          </div>
          <div class="document-panel-right mx-sm-1 mx-lg-2"  [hidden]="claimReason != '1'">
            <div class="title">Photos Of Damage to Package or Contents</div>
            <div class="doc-label-req-optional" *ngIf="!highlightRed">Required*</div>
            <div class="doc-label-req-optional-red" *ngIf="highlightRed">Required*</div>
            <div class="uploaded-documents d-flex justify-content-center align-items-center"
                [ngStyle]="{'border-color': (isDocumentMissing && photos.length < 1) ? 'red' : '#707070'}"
                (click)="!isUploadDisabled && PhotoInput.click()" upscDragNDrop (onFileDropped)="!isUploadDisabled && uploadDocument($event, 'ONL-Photo')">
                <input [disabled]="isUploadDisabled" hidden type="file" #PhotoInput (change)="uploadDocument($event.target.files, 'ONL-Photo', $event)" multiple>
                <div class="d-flex flex-column justify-content-center align-items-center">
                  <img class="pb-2" src="../../../../../assets/images/upload-file-icon.png">
                  <div class="attachments-title pb-2">
                    {{'claimsDetail.upload.message1.1' | translate }}
                  <span class="upload-underline">{{ 'claimsDetail.upload.message2.1' | translate }}</span>
                  </div>
                  <!-- <div class="pb-2">
                    {{ 'claimsDetail.upload.filesAllowed' | translate }}
                  </div> -->
                </div>
            </div>
            <div class="uploaded-attachments">
              <ul class="your-attachments">
                <li class="d-inline-flex justify-content-start align-items-center" *ngFor="let file of photos">
                  <div>{{file.file.name}}</div>
                  <mat-icon class="delete-icon ml-2" (click)="removeDocument(file, 'ONL-Photo')">clear</mat-icon>
                </li>
              </ul>
            </div>
          </div>
          <div class="document-panel-right ml-sm-1 ml-lg-2">
            <div class="title" *ngIf="proofOfValue!=='1'">
              Anything Else You'd Like To Provide
            </div>
            <div class="title-ssp" *ngIf="proofOfValue==='1'">
              <span class="text-100">Anything Else You'd Like To Provide</span>
            </div>
            <div class="doc-label-req-optional">Optional</div>
            <div class="uploaded-documents d-flex justify-content-center align-items-center"
                (click)="!isUploadDisabled && otherInput.click()" upscDragNDrop (onFileDropped)="!isUploadDisabled && uploadDocument($event, 'ONL-Other')">
                <input [disabled]="isUploadDisabled" hidden type="file" #otherInput (change)="uploadDocument($event.target.files, 'ONL-Other', $event)" multiple>
                <div class="d-flex flex-column justify-content-center align-items-center">
                  <img class="pb-2" src="../../../../../assets/images/upload-file-icon.png">
                  <div class="attachments-title pb-2">
                    {{'claimsDetail.upload.message1.1' | translate }}
                  <span class="upload-underline">{{ 'claimsDetail.upload.message2.1' | translate }}</span>
                  </div>
                  <!-- <div class="pb-2">
                    {{ 'claimsDetail.upload.filesAllowed' | translate }}
                  </div> -->
                </div>
            </div>
            <div class="uploaded-attachments">
              <ul class="your-attachments">
                <li class="d-inline-flex justify-content-start align-items-center" *ngFor="let file of others">
                  <div>{{file.file.name}}</div>
                  <mat-icon class="delete-icon ml-2" (click)="removeDocument(file, 'ONL-Other')">clear</mat-icon>
                </li>
              </ul>
            </div>
        </div>
      </div>
      </div>
    </div>
  </div>
</div>
